import { Route, Routes } from "react-router-dom";
import ProjectTasks from "../projectTasks";
import ProjectDetail from "./ProjectDetail";
import Projects from "./Projects";

const ProjectRoutes = () => {
  return (
    <Routes>
      <Route index element={<Projects />} />
      <Route path="tasks-overview" element={<ProjectTasks />} />
      <Route path=":id" element={<ProjectDetail />} />
    </Routes>
  );
};

export default ProjectRoutes;
